import i18n from "src/locales/i18n";

import { BusinessErrorCodes } from "src/types/business-errors";


export const getCreatePipelineErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.PaymentMethodError) {
    return i18n.t('admin-organization.settings.deal_flow_pipeline.api.create.name_in_use');
  }

  return i18n.t('admin-organization.settings.deal_flow_pipeline.api.create.default_error');
};

export const getUpdatePipelineErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.PipelineNameInUse) {
    return i18n.t('admin-organization.settings.deal_flow_pipeline.api.update.name_in_use');
  }

  return i18n.t('admin-organization.settings.deal_flow_pipeline.api.update.default_error');
};

export const getRemovePipelineErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.PipelineHasDeals) {
    return i18n.t('admin-organization.settings.deal_flow_pipeline.api.remove_pipeline.has_deals');
  }

  return i18n.t('admin-organization.settings.deal_flow_pipeline.api.remove_pipeline.default_error');
};

export const getRemoveStagePipelineErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.InvalidPipelineStage) {
    return i18n.t('admin-organization.settings.deal_flow_pipeline.api.remove_stage.not_found');
  }

  if (e?.data?.error_code === BusinessErrorCodes.PipelineMustHaveAtLeastOneStage) {
    return i18n.t('admin-organization.settings.deal_flow_pipeline.api.remove_stage.one_stage_required');
  }

  if (e?.data?.error_code === BusinessErrorCodes.PipelineStageHasDeals) {
    return i18n.t('admin-organization.settings.deal_flow_pipeline.api.remove_stage.has_deals');
  }

  return i18n.t('admin-organization.settings.deal_flow_pipeline.api.remove_stage.default_error');
};

export const getUpdateDealErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.DealIsArchived) {
    return i18n.t('deal_flow.api.update_deal.archived_deal');
  }

  return i18n.t('deal_flow.api.update_deal.default_error');
};

export const getUpdateDealStageErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.DealIsArchived) {
    return i18n.t('deal_flow.api.deal_stage_update.archived_deal');
  }

  return i18n.t('deal_flow.api.deal_stage_update.default_error');
};

export const getUpdateAssigneeErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.DealIsArchived) {
    return i18n.t('deal_flow.api.update_account_owner.archived_deal');
  }

  return i18n.t('deal_flow.api.update_account_owner.default_error');
};

export const getCreateJobErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.DealIsArchived) {
    return i18n.t('deal_flow.api.create_job.archived_deal');
  }

  if (e?.data?.error_code === BusinessErrorCodes.JobInfoNotAvailable) {
    return i18n.t('deal_flow.api.create_job.job_info_not_available');
  }

  if (e?.data?.error_code === BusinessErrorCodes.AssociatedJobExists) {
    return i18n.t('deal_flow.api.create_job.associated_job_exists');
  }

  return i18n.t('deal_flow.api.create_job.default_error');
};
